import { useParams } from 'react-router-dom';

import { ChannelVerifiedConfirmation } from '@identity/presentation/components/specific';
import type { VerifiedChannel } from '@identity/presentation/components/specific';
import { IdentityFlowProvider } from '@identity/presentation/context';

const isVerifiedChannel = (value?: string): value is VerifiedChannel => value === 'email' || value === 'phone';

/**
 * The final confirmation on the device that opened the link.
 *
 * It asks for nothing, offers no action, and deletes no cookie: it has none of its own, and the link
 * cookie is shared by the whole browser, so clearing it here would take the token away from a wizard
 * open in another tab.
 *
 * That wizard is told nothing from here. Its polling finds out on its own.
 *
 * The channel comes from the path, so it survives a reload. A path that names no known channel falls
 * back to the phone wording, which is the one nearly every link opened on a second device carries.
 */
export const ChannelVerifiedPage = () => {
  const { channel } = useParams<{ channel?: string }>();

  return (
    <IdentityFlowProvider flow="invitation">
      <ChannelVerifiedConfirmation channel={isVerifiedChannel(channel) ? channel : 'phone'} />
    </IdentityFlowProvider>
  );
};
